export default __webpack_public_path__ + "images/sell-page-test-hero.jpg";